import determineTarget from './determine-target';
import toggleElement from './toggle-element';
import setupFocusTrap from './focus-trap';
import historyStorage from './history-storage';

export default function setupTabs() {
	document.querySelectorAll( '.js-tab-set' ).forEach( tabSet => {
		const tabs = tabSet.querySelectorAll( '.js-tab' );
		const panels = tabSet.querySelectorAll( '.js-tab-panel' );

		// Mark all panels as hidden to start
		panels.forEach( panel => {
			panel.setAttribute( 'aria-hidden', true );
		} );

		function switchToTab( tab, focus ) {
			const panel = determineTarget( tab );

			toggleElement( panel, true, focus );
			historyStorage.setItem( tabSet.id, tab.id );

			panels.forEach( _panel => {
				if ( _panel.getAttribute( 'aria-hidden' ) === 'false' && _panel !== panel ) {
					toggleElement( _panel, false );
				}
			} );
		}

		tabs.forEach( tab => {
			tab.addEventListener( 'click', event => {
				event.preventDefault();
				switchToTab( tab, 'focus' );
			} );
		} );

		setupFocusTrap( tabSet, tabs, {
			arrowKeys: true,
			assumeFocusable: true,
		}, switchToTab );

		const currentId = historyStorage.getItem( tabSet.id );
		const currentTab = [ ...tabs ].find( tab => tab.id === currentId ) || tabs[ 0 ];

		switchToTab( currentTab );
	} );
}
